/**
 * HACK : 文字数を3点リーダーで省略して表示させたい場合に使用。以下のCSSは非推奨だが、一旦この関数を使用する。
 */
export const LINE_STYLE = (lines: number) => {
  return `
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: ${lines};
    -webkit-box-orient: vertical;
  `;
};
